const searchEn = {
  "nav.search_discovery": "Search & discovery",

  "palette.open": "Search",
  "palette.placeholder": "Search pages, settings, products, orders and customers",
  "palette.empty": "No results for “{q}”",
  "palette.hint": "Type to search. ↑ ↓ to move, Enter to open, Esc to close.",
  "palette.group.product": "Products",
  "palette.group.order": "Orders",
  "palette.group.customer": "Customers",
  "palette.unavailable": "Search isn't available right now.",

  "sd.title": "Search & discovery",
  "sd.tab.filters": "Filters",
  "sd.tab.synonyms": "Synonyms",
  "sd.tab.searches": "Searches",
  "sd.filters_hint": "Filters appear on collection and search pages in this order. Shoppers can combine them.",
  "sd.add_filter": "Add filter",
  "sd.no_filters": "No filters. Shoppers won't see filter options on your store.",
  "sd.filter_label": "Label",
  "sd.filter_source": "Source",
  "sd.kind.availability": "Availability",
  "sd.kind.price": "Price",
  "sd.kind.product_type": "Product type",
  "sd.kind.vendor": "Vendor",
  "sd.kind.tag": "Tag",
  "sd.kind.category": "Category",
  "sd.kind.option": "Product option",
  "sd.kind.metafield": "Product custom field",
  "sd.move_up": "Move up",
  "sd.move_down": "Move down",
  "sd.synonyms_hint": "Words in a group find the same products. Use it for spellings and both languages, like “عباية, abaya, abaaya”.",
  "sd.add_group": "Add synonym group",
  "sd.group_terms": "Words (comma separated)",
  "sd.no_synonyms": "No synonym groups yet.",
  "sd.synonyms_note": "Changes apply to search results within a few minutes.",
  "sd.top": "Top searches",
  "sd.no_results": "Searches with no results",
  "sd.no_results_hint": "Add synonyms or products for these.",
  "sd.term": "Search",
  "sd.count": "Searches",
  "sd.results": "Results",
  "sd.nothing_yet": "No searches in the last 30 days.",
  "sd.rebuild": "Rebuild search index",
  "sd.rebuild_body": "Rebuilds every product, page and post in search. Your store stays searchable while it runs.",
  "sd.rebuilding": "Rebuilding the search index…",
  "sd.disabled": "The search service isn't connected. Your store uses basic search until it is.",
  "sd.last_30": "Last 30 days",
} as const;

export default searchEn;
